import React from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <div className='footer_container'>
      <footer>
         <div className='logo'>
             <div className='image'>
                 <img src='./logo-no-background.png' alt='logo' width="100" height="100"/>
                 <h2>Top Fashion</h2>
             </div>
             <p id='quote'>Dress how you want to be addressed. </p>
         </div>
         <div className='service'>
             <header>Our Service</header>
             <Link to='/about' className='link'>About us</Link>
             <Link to='/'  className='link'>Our Products</Link>
             <Link to='/shop' className='link'>Shop</Link>
             <Link to='/' className='link'>Login</Link>
          
         </div>
         <div className='company'>
             <header>Company</header>
             <p>Terms of Use</p>
             <Link to='/contact' className='link'>Contact Us</Link>
             

         </div>
         <div className='socials'>
              <header>Follow Us</header>
              <a href="https://web.facebook.com/login.php/?_rdc=1&_rdr" target="_blank" rel="noopener noreferrer">Facebook</a>
              <a href="https://www.linkedin.com/in/rhoda-g-6129bb225/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://www.instagram.com/uniter_njeey/" target="_blank" rel="noopener noreferrer">Instagram</a>
              <a href="https://www.tiktok.com/login" target="_blank" rel="noopener noreferrer">TikTok</a>
              
         </div>
      </footer>
      <p>© 2023 Top Fashion. All rights reserved</p> 
    </div>
  )
}

export default Footer